export default __webpack_public_path__ + "static/media/bg1.77b806b8.jpg";